import { Component, Input } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { User } from 'src/app/classes/user.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { AuthorisationService } from 'src/app/services/auth/authorisation.service';
import { Features } from 'src/app/services/auth/features';
import { UserService } from 'src/app/services/user/user.service';

@Component({
    selector: 'app-user-login-info',
    standalone: false,
    templateUrl: './user-login-info.component.html',
    styleUrl: './user-login-info.component.scss',
})
export class UserLoginInfoComponent extends CodaltComponent {
    @Input() user: User;

    copied: 'pin' | 'password' | null = null;
    newPin: string;
    newPassword: string;
    generatingPin = false;
    pinError: string;
    generatingPassword = false;
    passwordError: string;

    constructor(private userService: UserService) {
        super();
    }

    get pincodeLoginAllowed(): boolean {
        return (
            !AuthorisationService.hasFeature(Features.PasswordLoginRequired, this.user) ||
            AuthorisationService.hasRole('dirkWithCode', this.user)
        );
    }

    get passwordLoginAllowed(): boolean {
        return !this.environment.microsoftLoginRequired || AuthorisationService.hasRole('dirkWithPassword', this.user);
    }

    resetLoginAttempts() {
        this.subscriptions.add(
            this.userService
                .resetLoginAttempts(this.user.id)
                .subscribe(({ total_login_attempts, last_login_attempt }) => {
                    this.user.total_login_attempts = total_login_attempts;
                    this.user.last_login_attempt = last_login_attempt;
                })
        );
    }

    getNewPin() {
        if (this.generatingPin) {
            return;
        }

        this.pinError = null;
        this.generatingPin = true;
        this.subscriptions.add(
            this.userService
                .newUserPin(this.user.id)
                .pipe(finalize(() => (this.generatingPin = false)))
                .subscribe({
                    next: ({ pin }) => {
                        this.newPin = pin;
                        // Uit het zicht halen zodra de code toch verlopen is (15min)
                        setTimeout(() => (this.newPin = null), 900000);
                    },
                    error: error => (this.pinError = error.message),
                })
        );
    }

    getNewPassword() {
        if (this.generatingPassword) {
            return;
        }

        this.passwordError = null;
        this.generatingPassword = true;
        this.subscriptions.add(
            this.userService
                .newUserPassword(this.user.id)
                .pipe(finalize(() => (this.generatingPassword = false)))
                .subscribe({
                    next: ({ password }) => {
                        this.newPassword = password;
                        // Niet eindeloos op het scherm laten staan; opnieuw genereren kan altijd (5min)
                        setTimeout(() => (this.newPassword = null), 300000);
                    },
                    error: error => (this.passwordError = error.message),
                })
        );
    }

    copyToClipboard(value: string, what: 'pin' | 'password') {
        navigator.clipboard.writeText(value).then(() => {
            this.copied = what;
            setTimeout(() => (this.copied = null), 2000);
        });
    }
}
